<template>
  <div class="agreement-pdf-scroller">
    <div v-if="status" class="pdf-status">{{ status }}</div>
    <div v-show="ready" ref="scroller" class="pdf-scroller" />
  </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'

pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/legacy/build/pdf.worker.min.js')

export default {
  name: 'AgreementPdfScroller',
  props: {
    pdfUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      status: '',
      ready: false,
    }
  },
  watch: {
    pdfUrl: {
      immediate: true,
      handler() {
        this.renderPdf()
      },
    },
  },
  methods: {
    clearScroller() {
      const scroller = this.$refs.scroller
      if (scroller) {
        scroller.innerHTML = ''
      }
      this.ready = false
    },
    async renderPdf() {
      this.clearScroller()
      if (!this.pdfUrl) {
        this.status = 'Agreement PDF is not available.'
        return
      }

      this.status = 'Loading agreement PDF...'

      try {
        const pdf = await pdfjsLib.getDocument(this.pdfUrl).promise
        const scroller = this.$refs.scroller

        if (!scroller) {
          return
        }

        this.status = `Total pages: ${pdf.numPages}`
        this.ready = true

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum)
          const viewport = page.getViewport({ scale: 1.25 })
          const canvas = document.createElement('canvas')
          canvas.className = 'pdf-page'
          canvas.width = viewport.width
          canvas.height = viewport.height
          const context = canvas.getContext('2d')
          await page.render({ canvasContext: context, viewport }).promise
          scroller.appendChild(canvas)
        }
      } catch (error) {
        this.status = 'Unable to render PDF here. Please use "Open PDF in new tab".'
        this.ready = false
      }
    },
  },
}
</script>

<style scoped>
.pdf-status {
  color: #6b7280;
  font-size: 14px;
  padding: 8px 2px;
}

.pdf-scroller {
  width: 100%;
  max-height: 420px;
  overflow-y: auto;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #f9fafb;
  padding: 12px;
}
</style>

<style>
.agreement-pdf-scroller .pdf-page {
  display: block;
  margin: 0 auto 12px auto;
  border: 1px solid #e5e7eb;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
</style>
